var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.467,
    height: 35.467,
    viewBox: "0 0 35.467 35.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 35.467,
    height: 35.467,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_615",
    "data-name": "Groupe 615",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_616",
    "data-name": "Groupe 616",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_544",
    "data-name": "Trac\\xE9 544",
    d: "M17.734,35.467A17.734,17.734,0,1,0,0,17.734,17.733,17.733,0,0,0,17.734,35.467",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_545",
    "data-name": "Trac\\xE9 545",
    d: "M19.314,16.237,25.153,9.4H22.42l-4.4,5.149L14.07,9.4H8.507l6.582,8.585L8.867,25.267H11.6l4.783-5.6,4.288,5.593h5.564Zm-7.633-5.289h1.641l9.744,12.764H21.424Z",
    transform: "translate(0.363 0.401)",
    fill: "#015289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon-x.ce780fd66ee41fcc076d564eca52a936.svg";
export { ForwardRef as ReactComponent };